import React, {MouseEvent, useCallback} from "react";
import styled from "@emotion/styled";
import {useDispatch, useSelector} from "react-redux";
import {IPlayer} from "modules/types";
import {addFanVotePlayer, removeFanVotePlayer, setIsOpenPlayerPool} from "modules/actions";
import {getFanVotePlayer} from "modules/selectors";
import {useIsMobile} from "modules/utils/hooks";
import {PureButton} from "components/Common";
import {ReactComponent as AddIcon} from "assets/images/icons/add.svg";
import {ReactComponent as RemoveIcon} from "assets/images/icons/remove.svg";

const ActionButton = styled(PureButton)`
	padding: 8px;

	&:disabled {
		opacity: 0.3;
	}
`;

interface IProps {
	player: IPlayer;
	isDisabled: boolean;
}

export const FanVoteActions: React.FC<IProps> = ({player, isDisabled}) => {
	const dispatch = useDispatch();
	const {isMobile} = useIsMobile("(max-width: 1000px)");
	const favVotePlayer = useSelector(getFanVotePlayer);
	const isPlayerSelected = favVotePlayer?.id === player.id;
	const isAddDisabled = isDisabled || Boolean(favVotePlayer);

	const addHandler = useCallback(
		(e: MouseEvent<HTMLButtonElement>) => {
			e.stopPropagation();

			dispatch(addFanVotePlayer(player.id));

			if (isMobile) {
				dispatch(setIsOpenPlayerPool(false));
			}
		},
		[dispatch, isMobile, player]
	);

	const handleRemove = useCallback(
		(e: MouseEvent<HTMLButtonElement>) => {
			e.stopPropagation();

			dispatch(removeFanVotePlayer());
		},
		[dispatch]
	);

	if (isPlayerSelected) {
		return (
			<ActionButton onClick={handleRemove} disabled={isDisabled}>
				<RemoveIcon />
			</ActionButton>
		);
	}

	return (
		<ActionButton onClick={addHandler} disabled={isAddDisabled}>
			<AddIcon />
		</ActionButton>
	);
};
